import { render, staticRenderFns } from "./SidebarTwo.vue?vue&type=template&id=511f63a8&"
import script from "./SidebarTwo.vue?vue&type=script&lang=js&"
export * from "./SidebarTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports